
import * as React from "react";
import {Row, Pagination, Col } from 'antd';
import ReactECharts from 'echarts-for-react';
import { assert_key } from "../../../helper";
import {getRawDataURL} from '../../../service/dataService';
import { start } from "repl";
export interface IProps {
  rawdata_list: any,
  image_width: any,
  image_height: any,
  row_image_num: any,
  task_name:any
}
export interface IState {
  current_page: number,
}

export default class ImageDisplay extends React.Component<IProps, IState>{
    public refresh_number: any = 1;
    constructor(props:IProps) {
        super(props);
        this.onPageChange = this.onPageChange.bind(this);
        this.renderImageDisplay = this.renderImageDisplay.bind(this);
        this.state = {
          current_page: 1,
        }
        // Flow:
        // 1. Constructor
        // 2. componentWillMount()
        // 3. render()
        // 4. componentDidMount()
        // If props update:
        // 4.1 componentWillReceiveProps(nextProps : IProps), then goto 5.
        // If States update
        // 5. shouldComponentUpdate() if return false, then no rerendering.
        // 6. if True, then componentWillUpdate
        // 7. render()
        // 8. componentDidUpdate
        // If Unmount, then componentWillUnmount()
    }
    public onPageChange(page_num:any){
      this.setState({
        current_page: page_num
      })
    }
    public renderImageDisplay = () => {
      // rawdata_list: ["src", "alt", "width", "height", "text_list", "col_size"]
      let {image_width, image_height, row_image_num} = this.props;
      let old_rawdata_list = this.props.rawdata_list;
      let col_size = Math.floor(24 / row_image_num);
      let rawdata_list:any = [];
      for(let i = 0; i<old_rawdata_list.length; i++){
        let pkg = {
          ...old_rawdata_list[i],
          "width": image_width,
          "height": image_height,
          "col_size": col_size
        }
        rawdata_list.push(pkg);
      }
      console.log("new rawdata list", rawdata_list)
      /** 
      let rawdata_list:any = [];
      let image_config = {
        "src": getRawDataURL(),
        "alt": "Girl in a jacket",
        "width": image_width,
        "height": image_height,
        "text_list": ["Ground Truth: Bird", "Confidence: 0.9"],
        "col_size": col_size,
    }
      for(let i = 0 ; i< 100; i++){
        let clone = JSON.parse(JSON.stringify(image_config));
        clone["text_list"].push(i);
           rawdata_list.push(clone);
      }
      */
      let total_item_num = rawdata_list.length;
      let total_page = Math.ceil(total_item_num / row_image_num);
      let current_page = this.state.current_page;
      if(total_page == 0){
        return <div />
      }
      if(this.state.current_page > total_page){
        this.setState({
          current_page: total_page
        })
        current_page = total_page;
      }
      if(this.state.current_page < 1){
        this.setState({
          current_page: 1
        })
        current_page = 1;
      }
    console.log("total page", total_page, "current page", current_page);
    let generate_file_contents = (config:any) => {
      if(this.props.task_name == "Image Tagging" || this.props.task_name == "Facial Emotion Recogntion"){
        return <img src={config["src"]} alt={config["alt"]} 
        width={config["width"]} height={config["height"]} />

      }else if(this.props.task_name == "Speech Recognition"){
        return <audio controls style={{"display": "block", 
                                      "transform": "scale(0.9, 1)", "transformOrigin": "left"}}>
          <source src={config["src"]} type="audio/wav"></source>
          Not supported!
        </audio>
      }else if(this.props.task_name == "Sentiment Analysis"){
        return <div  style={{"display": "block", "width": config["width"]}} ><object style={{"width": config["width"]}} data={config["src"]}></object></div>
      }else{
        return <div>Not supported tasks.</div>
      }
    }
    let generate_image_col = (config:any) => {
        let flag1 = assert_key(config, ["src", "alt", "width", "height", "text_list", "col_size"]);
        if(flag1){
           
            return <Col span={config["col_size"]} key={config["alt"]}>
                <Row>
                  {generate_file_contents(config)}
                
                </Row>
                {config["text_list"].map((d:any)=>{
                  return <Row>
                    {d}
                  </Row>
                }
                )}
            </Col>
        }else{
            return <div />
        }
    }
    let generate_image_rows = (current_page: number, num_per_page: number, rawdata_list:any) => {
      let start_point = (current_page - 1) * num_per_page;
      if(start_point < 0){
        start_point = 0;
      }
      let end_point = start_point + num_per_page;
      if(end_point >= rawdata_list.length){
        end_point = rawdata_list.length;
      }
      if(end_point < start_point){
        end_point = start_point;
      }

      let sliced_data = rawdata_list.slice(start_point, end_point);
      if(sliced_data.length == 0){
        return <div />
      }else{
        return sliced_data.map((d:any)=>{
          return generate_image_col(d);
        })
      }

    }
    return <Col span={24}>
          <Row>
          {generate_image_rows(current_page, row_image_num, rawdata_list)}
          </Row>
          <br />
          <Row  justify="center" align="middle" >
          <Col>

          
          <Pagination current={current_page} 
            total={total_page} 
            pageSize={1}
            onChange={this.onPageChange}
            />
            </Col>
          </Row>
          
    </Col>
  }
    

    public render() {

        return this.renderImageDisplay();
    }
}